import $ from 'jquery';
import React from 'react';
import FormRenderer from './formRenderer';
import stringToSha256 from './stringToSha256';

import { correctArticleHeight } from '../../articleHelper';
import { apiUrl } from '../../env';
import Steps from './Steps';

class Form extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      loading: false,
      fields: {
        id: '',
        consent: {
          implicit_description: '',
          further_implicit_description: '',
          explicit_description: '',
          explicit_required: false,
          further_explicit_description: '',
          further_explicit_required: false,
          marketing_description: ''
        },
        button_cta: '',
        button_style: '',
        button_alignment: '',
        fieldsets: [{ fields: [{ field_type: null }] }],
        show_placeholder_as_label: false,
        user_location: null,
        consultant: {
          table: {
            represents_branch: false,
            full_name: '',
            branch_name: '',
            infodesk_name: ''
          }
        },
        gtm_group: ''
      }
    };

    this.formUrl = apiUrl(location.hostname);
    this.uniqueFormId = ''
  }

  componentDidMount() {
    this.ajaxForm();
  }

  componentDidUpdate() {
    const { articleId, formId, contentArticleFormId, sugarEventId } = this.props;
    const { fields, loading } = this.state;

    if (!loading) {
      correctArticleHeight(articleId);

      FormRenderer.initMinRequired(
        parseInt(formId || fields.id, 10),
        parseInt(contentArticleFormId, 10),
        fields.fieldsets
      );

      this.setSugarEventId(sugarEventId);
      this.setupEmailObserver();
    }
  }

  setupEmailObserver() {
    const formElement = document.getElementById(this.uniqueFormId);
    if (formElement) {
      const emailInput = formElement.querySelector('input[name="email"]');
      if (emailInput && !emailInput.dataset.observed) { // Check if a listener already exists
        emailInput.dataset.observed = "true"; // Mark that the event listener has been set

        emailInput.addEventListener('blur', event => {
          const emailValue = event.target.value;
          const currentUrl = window.location.href;
          if (emailValue && (
            currentUrl.endsWith('/lp/erstberatung') ||
            currentUrl.endsWith('/lp/depot-check') ||
            currentUrl.endsWith('/lp/studien')
          )) {
            stringToSha256(emailValue).then(hash => {
              const hiddenField = document.querySelector('input[name="affiliate_order_id"]');
              if (hiddenField) {
                hiddenField.value = hash;
              }
            });
          }
        });
      }
    }
  }

  ajaxForm() {
    const { formId, title, tag } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    title && urlParams.append('title', title);
    tag && urlParams.append('tag', tag);

    if (formId || title || tag) {
      this.setState({ loading: true });

      // call ajax request only if one of titleParam or this.props.formId is present
      $.ajax({
        url: `${this.formUrl}/api/forms/${formId}?${urlParams.toString()}`,
        headers: {
          Accept: 'application/json'
        },
        xhrFields: {
          withCredentials: process.env.NODE_ENV == 'staging'
        },
        method: 'GET',
        success: (data) => {
          if (data) {
            // set `fields`-state for form and trigger componentDidUpdate for correct calculation of
            // article heights
            this.uniqueFormId = `content_article_form-${this.props.contentArticleFormId}-form_bases-${data.base.id}`;
            this.setState({ fields: data.base, loading: false });
          }
        }
      });
    }
  }

  setSugarEventId(sugarEventId) {
    const formElement = document.getElementById(this.uniqueFormId);
    if (formElement) {
      const sugarEventIdInput = formElement.querySelector('input[name="sugar_event_id"]');
      if (sugarEventIdInput && sugarEventId) {
        sugarEventIdInput.value = sugarEventId;
      }
    }
  }

  checkRequiredFields(e) {
    if (!e.target.checkValidity()) {
      // Filter form elements based on the presence of the 'required' attribute
      const requiredElements = Array.from(e.target.elements).filter((element) => element.required);

      // Find the first invalid field and set the step accordingly
      const invalidElement = requiredElements.find((element) => !element.validity.valid);
      const invalidFieldset = invalidElement.closest('.form-step');
      const invalidStep = invalidFieldset.dataset.step;

      // Press the back button in each section until the first bad step is reached
      for (let i = $('.form-step').length; i > invalidStep; i--) {
        $(`.form-step[data-step="${i}"]`).find('button').click();
      }
    }
  }

  displayRawContentInDiv(key, className = null) {
    if (!this.state.fields[key]) {
      return null;
    }

    return (
      <div className={className} dangerouslySetInnerHTML={{ __html: this.state.fields[key] }} />
    );
  }

  preContent() {
    return this.displayRawContentInDiv('pre_content');
  }

  trackingInfo() {
    return this.displayRawContentInDiv('tracking_info');
  }

  implicitConsent() {
    if (!this.state.fields.consent || !this.state.fields.consent.implicit_description) {
      return null;
    }

    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-implicit_consent-${this.state.fields.id}`;

    return (
      <div className="implicit-consent">
        <input type="hidden" name="implicit_consent" id={forId} value="true" />
        <div dangerouslySetInnerHTML={{ __html: this.state.fields.consent.implicit_description }} />
      </div>
    );
  }

  furtherImplicitConsent() {
    if (!this.state.fields.consent || !this.state.fields.consent.further_implicit_description) {
      return null;
    }

    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-further_implicit_consent-${this.state.fields.id}`;

    return (
      <div className="implicit-consent">
        <input type="hidden" name="further_implicit_consent" id={forId} value="true" />
        <div
          dangerouslySetInnerHTML={{
            __html: this.state.fields.consent.further_implicit_description
          }}
        />
      </div>
    );
  }

  explicitConsent() {
    if (!this.state.fields.consent || !this.state.fields.consent.explicit_description) {
      return null;
    }

    const labelText = (
      <div dangerouslySetInnerHTML={{ __html: this.state.fields.consent.explicit_description }} />
    );

    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-explicit_consent-${this.state.fields.id}`;

    const explicitInput = () => {
      if (this.state.fields.consent.explicit_required) {
        return <input type="checkbox" name="explicit_consent" id={forId} value="true" required />;
      }

      return <input type="checkbox" name="explicit_consent" id={forId} value="true" />;
    };

    return (
      <div className="explicit-consent">
        <input type="hidden" name="explicit_consent" id={`hidden-${forId}`} value="false" />
        <div className="formgroup input checkbox">
          <div className="clearfix">
            {explicitInput()}
            <label htmlFor={forId}>
              <span className="diamond-outer">
                <span className="diamond-inner" />
              </span>
              {labelText}
            </label>
          </div>
        </div>
      </div>
    );
  }

  furtherExplicitConsent() {
    if (!this.state.fields.consent || !this.state.fields.consent.further_explicit_description) {
      return null;
    }

    const labelText = (
      <div
        dangerouslySetInnerHTML={{ __html: this.state.fields.consent.further_explicit_description }}
      />
    );

    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-further_explicit_consent-${this.state.fields.id}`;

    const explicitInput = () => {
      if (this.state.fields.consent.further_explicit_required) {
        return (
          <input type="checkbox" name="further_explicit_consent" id={forId} value="true" required />
        );
      }

      return <input type="checkbox" name="further_explicit_consent" id={forId} value="true" />;
    };

    return (
      <div className="explicit-consent">
        <input type="hidden" name="further_explicit_consent" id={`hidden-${forId}`} value="false" />
        <div className="formgroup input checkbox">
          <div className="clearfix">
            {explicitInput()}
            <label htmlFor={forId}>
              <span className="diamond-outer">
                <span className="diamond-inner" />
              </span>
              {labelText}
            </label>
          </div>
        </div>
      </div>
    );
  }

  marketingConsent() {
    if (!this.state.fields.consent || !this.state.fields.consent.marketing_description) {
      return null;
    }

    const labelText = (
      <div dangerouslySetInnerHTML={{ __html: this.state.fields.consent.marketing_description }} />
    );

    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-marketing_consent-${this.state.fields.id}`;

    const marketingInput = () => {
      return <input type="checkbox" name="marketing_consent" id={forId} value="true" />;
    };

    return (
      <div className="marketing-consent">
        <input type="hidden" name="marketing_consent" id={`hidden-${forId}`} value="false" />
        <div className="formgroup input checkbox">
          <div className="clearfix">
            {marketingInput()}
            <label htmlFor={forId}>
              <span className="diamond-outer">
                <span className="diamond-inner" />
              </span>
              {labelText}
            </label>
          </div>
        </div>
      </div>
    );
  }

  preButtonContent() {
    return this.displayRawContentInDiv('pre_button_content', 'pre-button-content');
  }

  postButtonContent() {
    return this.displayRawContentInDiv('post_button_content', 'post-button-content');
  }

  headline() {
    return this.state.fields.headline ? <h3>{this.state.fields.headline}</h3> : null;
  }

  csrfToken() {
    const token = $('[name="csrf-token"]').attr('content');
    return <input name="authenticity_token" value={token} type="hidden" />;
  }

  userLocationCity() {
    const locationCity =
      (this.state.fields.user_location && this.state.fields.user_location.city) || '';
    return <input name="user_location[city]" value={locationCity} type="hidden" />;
  }

  userLocationCountry() {
    const locationCountryCode =
      (this.state.fields.user_location && this.state.fields.user_location.country_code) || '';
    return <input name="user_location[country]" value={locationCountryCode} type="hidden" />;
  }

  userLocationAddress() {
    const locationFullAddress =
      (this.state.fields.user_location && this.state.fields.user_location.full_address) || '';
    return <input name="user_location[full_address]" value={locationFullAddress} type="hidden" />;
  }

  userLocationLat() {
    const locationFullLat =
      (this.state.fields.user_location && this.state.fields.user_location.lat) || '';
    return <input name="user_location[lat]" value={locationFullLat} type="hidden" />;
  }

  userLocationLng() {
    const locationFullLng =
      (this.state.fields.user_location && this.state.fields.user_location.lng) || '';
    return <input name="user_location[lng]" value={locationFullLng} type="hidden" />;
  }

  formIdParam() {
    return (
      <input name="form-id" value={`${this.props.formId || this.state.fields.id}`} type="hidden" />
    );
  }

  contentArticleFormIdParam() {
    const contentArticleFormId = this.props.contentArticleFormId;

    if (!contentArticleFormId) return null;

    return <input name="content_article_form_id" value={contentArticleFormId} type="hidden" />;
  }

  honeypot() {
    return <input type="email" name="email-confirmation" className="hidden" />;
  }

  steppedFieldsets() {
    const { fields } = this.state;
    const { formId, contentArticleFormId } = this.props;
    const defaultElementsForLastStep = [
      <div key="form-cluster-spacer" className="form-cluster-spacer" />,
      this.furtherImplicitConsent(),
      this.explicitConsent(),
      this.furtherExplicitConsent(),
      this.marketingConsent(),
      this.preButtonContent(),
      !!fields.button_cta && (
        <input
          type="submit"
          value={fields.button_cta}
          className={`${fields.button_style} button-${fields.button_alignment}`}
        />
      ),
      this.postButtonContent(),
      this.implicitConsent()
    ];

    return (
      <Steps
        fields={fields}
        formId={formId}
        contentArticleFormId={contentArticleFormId}
        defaultElementsForLastStep={defaultElementsForLastStep}
      />
    );
  }

  render() {
    const { fields, loading } = this.state;
    const hasSteps =
      fields.fieldsets.some((fieldset) => fieldset.step > 1) &&
      !fields.fieldsets.every((fieldset) => fieldset.step === fields.fieldsets[0].step);
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const uniqueFormId = `${contentArticleFormId}-form_bases-${fields.id}`;

    if (loading) {
      return (
        <div>
          <i className="fa fa-spinner fa-pulse color-primary"></i> Formular wird geladen...
        </div>
      );
    }

    return (
      <div className={`form ${hasSteps ? 'form--stepped' : ''}`}>
        {this.headline()}
        {this.preContent()}
        {this.trackingInfo()}
        <form
          method="POST"
          action={`${this.formUrl}/submit-form`}
          id={uniqueFormId}
          data-gtm-group={fields.gtm_group}
          onSubmit={hasSteps ? this.checkRequiredFields : undefined}
        >
          {this.csrfToken()}
          {this.userLocationCity()}
          {this.userLocationCountry()}
          {this.userLocationAddress()}
          {this.userLocationLat()}
          {this.userLocationLng()}
          {this.formIdParam()}
          {this.contentArticleFormIdParam()}
          {this.honeypot()}
          {this.steppedFieldsets()}
        </form>
      </div>
    );
  }
}

Form.propTypes = {
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  articleId: React.PropTypes.number,
  sugarEventId: React.PropTypes.string,
  title: React.PropTypes.string,
  tag: React.PropTypes.string
};

export default Form;



// WEBPACK FOOTER //
// ./components/forms/form.js